import { Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { SelectItem } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { AttributeTypeService } from '../../../driver/services/attribute-type.service';
import { DriverRestrictionService } from '../../../driver/services/driver-restriction.service';
import { BaseComponent } from '../../../shared/base-components/base.component';

export class CustomerMrpRestrictionsEditModalComponentContext {
    constructor(
        public restrictionId: number,
        public customerNumberId: number) {}
}

@Component({
    selector: 'customer-mrp-restrictions-edit-modal',
    templateUrl: './customer-mrp-restrictions-edit-modal.html'
})
export class CustomerMrpRestrictionsEditModalComponent extends BaseComponent {
    public form: UntypedFormGroup;
    public loading = true;
    public saving = false;
    public personRestrictionItems: SelectItem[] = [];
    private driverAttribute: any;

    constructor(
        public dialogRef: MatDialogRef<CustomerMrpRestrictionsEditModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: CustomerMrpRestrictionsEditModalComponentContext,
        private formBuilder: UntypedFormBuilder,
        private attributeTypeService: AttributeTypeService,
        private driverRestrictionService: DriverRestrictionService
    ) {
        super();
        this.form = this.formBuilder.group({
            restrictionDescription: ['', Validators.maxLength(255)]
        });
    }

    public async ngOnInit() {
        this.driverRestrictionService.getDriverRestriction(this.data.restrictionId)
            .subscribe(r => {
                this.driverAttribute = r;
                this.form.get('restrictionDescription').setValue(this.driverAttribute.description);
            });
    }

    public cancel = (): void => {
        this.dialogRef.close();
    };

    public save = (): void => {
        if (this.form.valid) {
            let restrictions = [];
            let restrictionDescription = this.form.get('restrictionDescription').value;
            this.driverAttribute.description = restrictionDescription;
            restrictions.push(this.driverAttribute);
            this.saving = true;

            this.driverRestrictionService.saveCustomerAttributes(restrictions).pipe(
                finalize(() => this.saving = false))
                .subscribe(
                    r => this.dialogRef.close(true),
                    e => this.handleValidationResult(e)
                );
        }
    };
}
